<div class="help-center-header">
    <!--<i class="pi pi-question-circle help-center-header-icon"></i>
    <h1>Centro de ayuda</h1>-->
    <p>Encuentra todo lo que necesitas para sacar el máximo partido a GUAI</p>
</div>
<div class="help-center-container">
    <div class="help-center-grid">
        <div class="help-card" (click)="openUserManual()">
            <div class="help-card-icon-wrapper manual">
                <i class="pi pi-book"></i>
            </div>
            <div class="help-card-content">
                <h3>Manual de configuración</h3>
                <p>Guía completa con todas las funcionalidades de la plataforma</p>
            </div>
            <div class="help-card-arrow">
                <i class="pi pi-arrow-right"></i>
            </div>
        </div>
    </div>
</div>

<div class="help-center-header pt-4">
    <!--<i class="pi pi-question-circle help-center-header-icon"></i>
    <h1>Centro de ayuda</h1>-->
    <p>Encuentra todo lo que necesitas para sacar el máximo partido a la aplicación móvil de GUAI</p>
</div>
<div class="help-center-container">
    <div class="help-center-grid">
        <div class="help-card" (click)="openUrl('https://cuidacasa.sharepoint.com/:b:/s/GrupoCuidaCasa/IQCSs8tX9ypFRpfLXkz0fUqEAX6j-2omY5IKk4512rJ1rQk?e=D5Uz3c')">
            <div class="help-card-icon-wrapper manual">
                <i class="pi pi-book"></i>
            </div>
            <div class="help-card-content">
                <h3>Manual aplicación móvil</h3>
                <p>Guía completa con todas las funcionalidades de la aplicación móvil</p>
            </div>
            <div class="help-card-arrow">
                <i class="pi pi-arrow-right"></i>
            </div>
        </div>
        <div class="help-card" (click)="openUrl('https://cuidacasa.sharepoint.com/:v:/s/GrupoCuidaCasa/IQBQtoaJH9cGTqjg99yDe4isAXtHhMT1XRsHo_v3F5bbJq8?e=FYphjw&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D')">
            <div class="help-card-icon-wrapper manual">
                <i class="pi pi-video"></i>
            </div>
            <div class="help-card-content">
                <h3>Introducción a la aplicación móvil</h3>
                <p>Guía completa con todas las funcionalidades de la aplicación móvil</p>
            </div>
            <div class="help-card-arrow">
                <i class="pi pi-arrow-right"></i>
            </div>
        </div>
        <div class="help-card" (click)="openUrl('https://cuidacasa.sharepoint.com/:v:/s/GrupoCuidaCasa/IQDk4LrlqcCQQ6eyLGfa7fFQAYgDHlcYygpCzLt4vFBe8co?e=uBvj9n&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D')">
            <div class="help-card-icon-wrapper manual">
                <i class="pi pi-video"></i>
            </div>
            <div class="help-card-content">
                <h3>Aplicación móvil - Servicios confirmados</h3>
                <p>Guía servicios confirmados</p>
            </div>
            <div class="help-card-arrow">
                <i class="pi pi-arrow-right"></i>
            </div>
        </div>
    </div>
</div>
